// import { Settings } from "lucide-react";

// const processes = [
//   "3D Printing", "CNC Machining", "Laser Cutting", "PCB Manufacturing",
//   "Electronics Assembly", "Injection Moulding", "Sheet Metal", "Welding",
//   "Robotics", "Composites",
// ];

// export default function ManufacturingProcessStep({ formData, updateField }) {
//   return (
//     <div className="grid sm:grid-cols-2 gap-4">
//       {processes.map((process) => {
//         const isSelected = formData.process === process;
//         return (
//           <button
//             key={process}
//             type="button"
//             onClick={() => updateField("process", process)}
//             className={`flex items-center gap-3 px-5 py-4 rounded-xl border font-semibold text-sm transition ${
//               isSelected
//                 ? "bg-gradient-to-r from-indigo-600 to-blue-500 border-transparent text-white"
//                 : "bg-white border-gray-200 text-gray-800 hover:border-indigo-300"
//             }`}
//           >
//             <Settings className={`w-4 h-4 ${isSelected ? "text-white" : "text-blue-500"}`} />
//             {process}
//           </button>
//         );
//       })}
//     </div>
//   );
// }




import { Settings } from "lucide-react";

const processes = [
  "3D Printing", "CNC Machining", "Laser Cutting", "PCB Manufacturing",
  "Electronics Assembly", "Injection Moulding", "Sheet Metal", "Welding",
  "Robotics", "Composites",
];

const materials = [
  "Plastic", "Metal", "Aluminium", "Steel", 
  "Stainless Steel", "ABS", "PLA"
];

export default function ManufacturingProcessStep({ formData, updateField }) {
  const toggleProcess = (process) => {
    const current = formData.manufacturingProcesses || [];
    if (current.includes(process)) {
      updateField("manufacturingProcesses", current.filter(p => p !== process));
    } else {
      updateField("manufacturingProcesses", [...current, process]);
    }
  };

  const toggleMaterial = (material) => {
    const current = formData.requiredMaterials || [];
    if (current.includes(material)) {
      updateField("requiredMaterials", current.filter(m => m !== material));
    } else {
      updateField("requiredMaterials", [...current, material]);
    }
  };

  return (
    <div className="space-y-6">
      {/* Manufacturing Processes */}
      <div>
        <span className="block text-sm font-medium text-gray-700 mb-3">Manufacturing Processes</span>
        <div className="grid sm:grid-cols-2 gap-3">
          {processes.map((process) => {
            const isSelected = (formData.manufacturingProcesses || []).includes(process);
            return (
              <button
                key={process}
                type="button"
                onClick={() => toggleProcess(process)}
                className={`flex items-center gap-3 px-5 py-4 rounded-xl border font-semibold text-sm transition ${
                  isSelected
                    ? "bg-gradient-to-r from-indigo-600 to-blue-500 border-transparent text-white"
                    : "bg-white border-gray-200 text-gray-800 hover:border-indigo-300"
                }`}
              >
                <Settings className={`w-4 h-4 ${isSelected ? "text-white" : "text-blue-500"}`} />
                {process}
              </button>
            );
          })}
        </div>
      </div>

      {/* Required Materials */}
      <div className="pt-6 border-t border-gray-100">
        <span className="block text-sm font-medium text-gray-700 mb-3">Required Materials</span>
        <div className="flex flex-wrap gap-2">
          {materials.map((material) => {
            const isSelected = (formData.requiredMaterials || []).includes(material);
            return (
              <button
                key={material}
                type="button"
                onClick={() => toggleMaterial(material)}
                className={`text-sm font-medium px-4 py-2 rounded-full border transition ${
                  isSelected
                    ? "bg-indigo-600 border-indigo-600 text-white"
                    : "bg-white border-gray-200 text-gray-700 hover:border-indigo-300"
                }`}
              >
                {material}
              </button>
            );
          })}
        </div>
      </div>

      {/* Manufacturing Requirements */}
      <div className="pt-6 border-t border-gray-100">
        <label className="block">
          <span className="block text-sm font-medium text-gray-700 mb-1.5">Manufacturing Requirements</span>
          <textarea
            value={formData.manufacturingRequirements}
            onChange={(e) => updateField("manufacturingRequirements", e.target.value)}
            placeholder="Any specific manufacturing requirements, tolerances, or quality standards..."
            rows={3}
            className="w-full border border-gray-200 rounded-xl px-4 py-3 text-sm resize-y focus:outline-none focus:ring-2 focus:ring-indigo-500 focus:border-transparent"
          />
        </label>
      </div>
    </div>
  );
}